import { Channel, IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const liveChat: IMcAppType = {
  name: "liveChat",
  path: "/contact.html",
  description: "Live Chat with an agent",
  navFlow: NavFlow.EXTERNAL,
  title: "Live Chat",
  parent: Tab.MORE,
  conditions: {
    intent: "liveChat",
    channel: Channel.WEB,
  },
};

export const liveChat_NATIVE: IMcAppType = {
  name: "liveChat_NATIVE",
  description: "Live Chat with an agent for native",
  path: "/chat-oiw.html",
  navFlow: NavFlow.EXTERNAL,
  title: "Live Chat",
  parent: Tab.MORE,
  conditions: {
    intent: "liveChat",
    channel: Channel.NATIVE,
  },
};
